module.exports = __webpack_public_path__ + "static/media/ralko-r.50167d2c.png";